import { useContext } from 'react'
import { HeroContext } from '../providers'

export const useHero = () => {
  return useContext(HeroContext)
}
